import request from "@/app/api/request";
import {ReviewModel, ReviewRequestModel, SetReviewRequestModel} from "@/app/api/reviews/models";

export class ReviewsRequests {
  static async getCourtReview(model: ReviewRequestModel): Promise<ReviewModel[]> {
    try {
      return await request.get<ReviewModel[]>('/courtsReviews/getCourtReviews', {query: model});
    } catch (error: any) {
      throw error;
    }
  }

  static async setCourtsReview(data: SetReviewRequestModel, courtId: number): Promise<ReviewModel> {
    try {
      return await request.post<ReviewModel>('/courtsReviews/addReview', {query: {courtId}, data});
    } catch (error: any) {
      throw error;
    }
  }
}

